

















































































































































import Vue, { VueConstructor } from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import validationMixin, {
  ValidatableForm,
} from "@/components/mixins/validationMixin";
import { Playlist } from "@/models/playlist";
import VaButton from "@/components/atoms/VaButton.vue";
import VaTextArea from "@/components/atoms/VaTextArea.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import { Media } from "@/models/media";
import VaBack from "@/components/molecules/VaBack.vue";
import YoutubeMediaPopup from "@/components/pages/digitalSignage/YoutubePopup.vue";
import MediaPopup from "@/components/pages/digitalSignage/MediaPopup.vue";
import VaSwitch from "@/components/atoms/VaSwitch.vue";
import draggable from "vuedraggable";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof validationMixin>>
).extend({
  name: "SignagePlaylistDetail",
  mixins: [validationMixin],
  components: {
    MediaPopup,
    YoutubeMediaPopup,
    VaBack,
    VaButton,
    VaTextArea,
    VaTextField,
    VaCard,
    MainColumns,
    Notifications,
    VaSwitch,
    draggable,
  },
  data() {
    return {
      imageFit: "cover" as string,
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.$store.dispatch("playlist/getPlaylist", this.$route.params.id);
      this.$store.dispatch("media/fetchAll");
      const media = this.playlist?.config?.media;
      if (media && media.length > 0) {
        const first = media.find((m) => m.objectFit);
        if (first?.objectFit) {
          this.imageFit = first.objectFit;
        }
      }
    }
  },
  methods: {
    onChangeMedia(val: Media[]): void {
      if (this.playlist) {
        this.playlist.config.media = val;
      }
    },
    onRemoveMedia(item: Media): void {
      if (this.playlist) {
        const list = this.playlist.config.media.filter(
          (m) => m.companyMediaId != item.companyMediaId
        );
        this.playlist.config.media = list;
        this.playlist.media = list;
      }
    },
    onAddYoutube(ytMedia: Media) {
      if (this.playlist) {
        this.playlist.config.media.push(ytMedia);
      }
    },
    onDelete(): void {
      this.$store.dispatch("playlist/deletePlaylist");
    },
    onSave(): void {
      if (
        (this.$refs.editPlaylistForm as ValidatableForm).validate() &&
        this.playlist
      ) {
        this.playlist.config.media.forEach((m) => {
          m.objectFit = this.imageFit;
        });
        this.playlist.media = this.playlist.config.media.filter(
          (m) => m.fileType != "youtube"
        );
        this.$store.dispatch("playlist/updatePlaylist", this.playlist);
      }
    },
  },
  computed: {
    playlist(): Playlist | undefined {
      return this.$store.getters["playlist/currenPlaylist"];
    },
    availableMedia(): Media[] | undefined {
      return this.$store.getters["media/allMedia"].filter((m: Media) => {
        return (
          m.fileType == "video" || m.fileType == "image" || m.fileType == "pdf"
        );
      });
    },
  },
});
